export const activationStates = {
    PENDING_COMPLETION: "PENDING_COMPLETION",
    CANCELLED: "CANCELLED",
    PENDING_CONFIRMATION: "PENDING_CONFIRMATION",
    WAITING_FOR_SERVER_CODE: "WAITING_FOR_SERVER_CODE",
    COMPLETED: "COMPLETED",
};

export const serverSizes = [
    {value: "small", label: "Small"},
    {value: "medium", label: "Medium"},
    {value: "large", label: "Large"},
    {value: "xl", label: "XL"},
];
